var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agenda-title[data-v-48d98e25]{text-shadow:1px 5px 4px #000}.container-top[data-v-48d98e25]{background:url(" + escape(require("./assets/images/topo_fispalfood_2020.png")) + ") no-repeat 50% #0d0f0e}.container-top .container[data-v-48d98e25]{height:180px}.slide-fade-enter-active[data-v-48d98e25]{transition:all .6s ease;transition-delay:.8s}.slide-fade-leave-active[data-v-48d98e25]{transition:all .6s cubic-bezier(1,.5,.8,1)}.slide-fade-enter[data-v-48d98e25],.slide-fade-leave-to[data-v-48d98e25]{transform:translateX(10px);opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48d98e25","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 168
// module chunks = 0